import apiClient from '../../shared/services/apiClient';

/** 用户通知中心 /api/user/notifications/*。错误统一抛出 {error} 体。 */
const call = async (p) => {
    try {
        const res = await p;
        return res.data?.data;
    } catch (e) {
        throw e.response?.data || e;
    }
};

const BASE = '/api/user/notifications';

const notificationService = {
    overview: () => call(apiClient.get(BASE)),
    savePrefs: (prefs) => call(apiClient.put(`${BASE}/prefs`, { prefs })),
    telegramBindCode: () => call(apiClient.post(`${BASE}/telegram/bind-code`)),
    telegramStatus: (code) => call(apiClient.get(`${BASE}/telegram/status`, { params: { code } })),
    removeChannel: (id) => call(apiClient.delete(`${BASE}/channels/${id}`)),
    test: (channel, channelId) => call(apiClient.post(`${BASE}/test`, channelId ? { channel, channel_id: channelId } : { channel })),
    inbox: (params) => call(apiClient.get(`${BASE}/inbox`, { params })),
    unreadCount: () => call(apiClient.get(`${BASE}/inbox/unread-count`)),
    markRead: (ids) => call(apiClient.post(`${BASE}/inbox/read`, ids ? { ids } : { all: true })),
};

/** 其他组件（铃铛）监听未读数变化 */
export const UNREAD_EVENT = 'yc:notify-unread';
export const emitUnread = (n) => {
    try { window.dispatchEvent(new CustomEvent(UNREAD_EVENT, { detail: n })); } catch (_) { /* noop */ }
};

export default notificationService;
